module.exports = __webpack_public_path__ + "app/community/modals/modal-delete-comunity-2Yk9SEOw.html";